import { environment } from 'src/environments/environment';

/**
 * API origin for non-GT endpoints (e.g. PARA), derived from {@link environment.apiUrl}.
 *
 * Historically, `environment.apiUrl` points at the GT base (often ending in `/gt`).
 * PARA endpoints live at the same origin without the `/gt` suffix.
 */
export function apiRootUrl(): string {
	return String(environment.apiUrl || '').replace(/\/gt\/?$/i, '');
}

